import React from "react";
import {createRoot} from "react-dom/client";

import {RadiantApp} from "./RadiantApp";

const container = document.querySelector("#root") as HTMLDivElement;
const root = createRoot(container);

root.render(<RadiantApp />);
